import React from "react";

 export const ResultPage = ()=>{
    return(
        <>
        <div className="Result-Page-MD">

        <h3 className="WelcomeBack">Welcome Back,Manthan...</h3>
        <h1 className="Scoreis">Your Score is<br></br>
            High </h1>
            <h1 className="Sticker">😎</h1>
            <h1 className="Result">12</h1>
            <h3 className="Outof">Out Of 20</h3>
            <h4 className="Answers">Your score is based on the correct Answers you give. </h4>
        </div>
        
        </>
    )
}